import {SearchFilterModel} from '../../models/SearchFilter-model';

// Older saved filters used autocomplete enum names. The Master filtering API
// accepts the entity's field names instead.
const legacyMasterFilterFields: Record<string, string> = {
    VEHICLE_PRODUCER: 'vehicleProducer',
    VEHICLE_SERIES: 'vehicleSeries',
    VEHICLE_MODEL: 'vehicleModel',
    VEHICLE_TYPE: 'vehicleType',
    ECU_BUILD: 'ecuBuild',
    ECU_PRODUCER: 'ecuProducer'
};

export function normalizeMasterFilters(filters: SearchFilterModel[]): SearchFilterModel[] {
    return (filters ?? [])
        .filter(filter => filter?.option && filter.value != null && String(filter.value).trim().length > 0)
        .map(filter => ({
            ...filter,
            option: legacyMasterFilterFields[filter.option] ?? filter.option,
            value: String(filter.value).trim()
        }));
}
